import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras, RoutesRecognized } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service'

@Component({
  selector: 'app-website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.scss'],
})
export class WebsiteFooterComponent implements OnInit {

  constructor(
    private router: Router,
    private routerActivate: ActivatedRoute,
    public alertController : AlertController,
    public userService: UserService,
  ) { }

  ngOnInit() {}

  
  raiseissue() {
    this.router.navigate(['/raise-issue'])
  }

  // async presentAlert() {
  //   const alert = await this.alertController.create({
  //     cssClass: 'my-custom-class',
  //     header: 'Contact Us',
  //     subHeader: 'Send email with your query at',
  //     message: 'noreply@spotcustomers.com',
  //     buttons: ['OK']
  //   });
  
  //   await alert.present();
  // }
  present() {
    this.router.navigate(["/contact"])
  }
  PP(){
    this.router.navigate(['/privacy-page'])
  }
  TandC(){
    this.router.navigate(['/termsandconditions'])
  }
  SP(){
    this.router.navigate(['/shippingpolicy'])
  }
  RandC(){
    this.router.navigate(['/refundandcancellation'])
  }
  app(){
    window.open("https://play.google.com/store/apps/details?id=com.spot.mckinsol&hl=en_IN&gl=US")
  }
}
